import { createFileRoute } from "@tanstack/react-router";

import { SimulationsScreen } from "../features/simulation/SimulationsScreen.tsx";

export const Route = createFileRoute("/_app/simulations")({
  component: SimulationsScreen,
});
